<template>
<div class="col backgroundForm">
    <div class="col col-md-10 offset-md-1">
        <h3 clas="col" align="center">Novedades/Reportes Importantes </h3>
        <h6 align="right"></h6>
        
        <nav>
            <div class="nav nav-pills" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-init-traffic" data-toggle="tab" href="#list-nov" role="tab" aria-controls="nav-home" aria-selected="true"> <font-awesome-icon icon="list" /> Reporte</a>    
            </div>
        </nav>
        
        <div class="tab-content" id="nav-tabContent">
            <br>            
            <div class="tab-pane fade show active"  id="list-nov" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="input-group mb-3 col-12 col-md-8 offset-md-2">
                    <select name="captain_download" class="form-control" id="captain_download" v-model="port_select_novedad">
                        <option v-for="port in ports_vigency" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                    </select>
                    <input type="date" class="form-control" placeholder="Fecha de Registros" aria-describedby="basic-addon2" v-model="fecha_novedades">
                    <div class="input-group-append">
                        <button class="btn btn-outline-success" type="button" @click="mLlamaNovedades('cf')">A la Fecha</button>
                    </div>
                    <div class="input-group-append">
                        <button class="btn btn-outline-danger" type="button" @click="mLlamaNovedades('na')">No Atendidos</button>
                    </div>
                </div>

                <br><br>
                <!-- aqui listamos los registros -->
                 <div class="table-responsive" id="printTable">
                    <table class="table table-sm table-hover" v-if="dts_novedad.length>0">
                        <thead>
                            <tr style="font-size: 12px;">
                                <th align="center" class="align-middle" >#</th>
                                <th align="center" class="align-middle" >CC.PP.</th>
                                <th align="center" class="align-middle" >FECHA/HORA REGISTRO</th>
                                <th align="center" class="align-middle" >NOVEDAD</th>
                                <th align="center" class="align-middle" >ATENDIDO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dn, index) in dts_novedad" :key="dn.id_novedad" style="font-size: 12px;">
                                <td class="align-middle">{{ index+1 }}</td>
                                <td class="align-middle">{{ dn.name_port }}</td>
                                <td class="align-middle">{{ $dateMilitary2(dn.fecha_reg) }}</td>
                                <td><div v-html="dn.novedades"></div></td>
                                <td align="center" class="align-middle" :class="dn.atendido ==='N' ? 'alert alert-danger':'alert alert-success'">{{ dn.atendido ==='N' ? 'NO': 'SI' }}<br> <button :disabled="animate" class="btn btn-success" v-if="dn.atendido==='N'" @click="mAtenderAsunto(dn.id_novedad)"><font-awesome-icon icon="check" :bounce="animate" /></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div><!-- aqui termina el div de la tabla de las novedades -->
            </div>
        </div>
        
    
    </div>
</div>
</template>
<script type="ts">
import Vue from 'vue';
import axios from 'axios'
const qs= require('qs');

import { VueEditor } from "vue2-editor";
import { computed } from 'vue';

// customToolbar: [
//             ["bold", "italic", "underline"],
//             [{ list: "ordered" }, { list: "bullet" }],
//             ["image", "code-block"]
//         ],

export default{
    name:'novedades',
    data(){
        return{
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["code-block"]
            ],
            novedades_reg:'',
            animate_register:false,
            dts_novedad:[],
            fecha_novedades:'',
            ports_vigency:[],
            port_select_novedad:0,
            animate:false
        }
    },
    mounted() {
        this.mCargaInicial();
        
    },
    methods: {
        async mAtenderAsunto(id_novedad){
            try {
                this.animate=true;
                let aux_novedad={
                    id_novedad:id_novedad,
                    nestado:'S'
                }
                let aux_aprob=await axios.post(`approbeNovedad?api_token=${Vue.auth.getToken()}`, qs.stringify(aux_novedad));
                console.log(aux_aprob);
                let idxb=this.dts_novedad.findIndex(elb=> elb.id===id_novedad);
                this.dts_novedad.splice(idxb, 1);
                setTimeout(()=>{
                    this.animate=false;
                }, 1500);

            } catch (error) {
                console.log(error);
            }
        },
        async mCargaInicial(){
            this.fecha_novedades=this.$dateActually();
            this.ports_vigency=[];
            let aux_p2={
                id:'all',
                name_port:'TODAS LAS CAPITANIAS'
            }
            this.ports_vigency.push(aux_p2);
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            ports.data.forEach(elp => {
                let aux_p={
                    id:elp.id,
                    name_port:elp.name_port
                }
                this.ports_vigency.push(aux_p);
            });
        },
        async mLlamaNovedades(tipo='cf'){
            try {
                this.dts_novedad=[];
                if(this.port_select_novedad!==0){
                    // aqui se llama al servidor para obtener la informacion de las novedades registradas
                    let busca_novedades=await axios.get(`searchNovedades/${tipo}/${this.port_select_novedad}/${this.fecha_novedades}?api_token=${Vue.auth.getToken()}`);
                    console.log(busca_novedades);
                    if(busca_novedades.data[0].status){
                        this.dts_novedad=busca_novedades.data[0].novedades;
                    }else{
                        toastr.warning(`No se ha encontrado ningún registro`);
                    }
                }else{
                    toastr.warning('seleccione una CC.PP.')
                }
                
            } catch (error) {
                console.log(error);
            }
        },
        async mRegisterNovedad(){
            try {
                if(this.novedades_reg!=='' &&this.novedades_reg.length>0){
                    this.animate_register=true;
                    let aux_novedad={
                        novedad:this.novedades_reg,
                        capitania:this.cDtsUser.portId
                    }
                    let aux_register=await axios.post(`registerNovedad?api_token=${Vue.auth.getToken()}`,  qs.stringify(aux_novedad));
                    if(aux_register.data.status){
                        toastr.success(`${aux_register.data.response}`);
                        this.novedades_reg='';
                    }else{
                        toastr.danger(`${aux_register.data.response}`);
                    }
                    setTimeout(()=>{
                        this.animate_register=false;
                    }, 1000)
                    console.log(this.novedades_reg);
                }else{
                    toastr.warning('Debe señalar un dato de novedad para su registro');
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
    },
    components: { VueEditor }
}

</script>
<style lang="css">
/* @import "~vue2-editor/dist/vue2-editor.css"; */

/* Import the Quill styles you want 
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css'; */
</style>


// WEBPACK FOOTER //
// src/components/captain/NovedadesAdmin.vue